import { CanActivateFn, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, filter, map, of, switchMap } from 'rxjs';
import { select, Store } from '@ngrx/store';
import {
  UserSessionsState,
  UserSessionStoreSelectors,
} from '@booking-booster-client/root-store';
import { AuthService } from '../services/auth.service';

@Injectable()
export class SigninGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
    private store: Store<UserSessionsState>,
  ) {}

  canActivate: CanActivateFn = () => {
    return this.authService.isInitialized$.pipe(
      filter((initialized) => !!initialized),
      switchMap(() => {
        if (this.authService.hasValidAccessToken()) {
          return combineLatest([
            this.store.pipe(select(UserSessionStoreSelectors.selectUser)),
            this.store.pipe(select(UserSessionStoreSelectors.selectError)),
          ]).pipe(
            filter(([user, error]) => !!user || !!error), //undefined significa non caricato
            map(([user]) => {
              if (!user) {
                return true;
              }

              return this.router.createUrlTree(['/']);
            }),
          );
        } else {
          this.authService.initLoginFlow();
          return of(this.router.createUrlTree(['/']));
        }
      }),
    );
  };
}
